import React from 'react';
import SurveyStepBar from 'components/SurveyVehicle/SurveyStepBar';
import { IStepElems } from 'components/SurveyVehicle/SurveyStepBar/types';
import SurveyPage from 'components/SurveyVehicle/SurveyPage';
import { IContent } from 'components/SurveyVehicle/SurveyPage/types';
import _ from 'lodash';
import commonService from 'utils/commonService';
import apiCommonService from 'bff/services/commonService';
import { IProps, IState } from './types';
import { CodeId } from 'constants/enums/codeId.enum';
import service from 'bff/services/surveyVehicleService';
import { CarSurveyImage } from 'bff/models/surveyVehicle/imageList';
import sweetAlertService from 'utils/sweetAlertService';
import SurveyCompleted from 'components/SurveyVehicle/SurveyCompleted';
import { SurveyStepInfoContent, StepInfoItemContent } from 'bff/models/surveyVehicle';
import { RouterSettings } from 'constants/models/routerSettings';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import { CodeClass } from 'constants/enums/codeClass.enum';

// const steps: IStepElems[] = [
//   { index: '01', text: '車頭' },
//   { index: '02', text: '駕駛座' },
//   { index: '03', text: '車尾' },
//   { index: '04', text: '副駕駛座' },
//   { index: '05', text: '其他' }
// ];

// const pages: IContent[] = [
//   { title: '車頭', desc: '正對愛車車頭並確認車牌清晰、車頭全景(含擋風玻璃)入鏡。' },
//   { title: '駕駛座前側', desc: '駕駛座前側45度角並確認車身無遮擋，車門及車窗正常關閉。' },
//   { title: '駕駛座側', desc: '駕駛座方全車側面並確認車身無遮擋，車門及車窗正常關閉。' },
//   { title: '駕駛座後側', desc: '駕駛座後側45度角並確認車身無遮擋，車門及車窗正常關閉。' },
//   { title: '車尾', desc: '正對愛車車尾並確認車牌清晰、車尾全景(含後擋風玻璃)入鏡。' },
//   { title: '副駕駛後側', desc: '副駕駛座後側45度角並確認車身無遮擋，車門及車窗正常關閉。' },
//   { title: '副駕駛側', desc: '副駕駛座方全車側面並確認車身無遮擋，車門及車窗正常關閉。' },
//   { title: '副駕駛前側', desc: '副駕駛座前側45度角並確認車身無遮擋，車門及車窗正常關閉。' },
//   { title: '引擎號碼或車身號碼', desc: '引擎號碼位置通常在引擎與變速箱中間，車身號碼位置通常在車體主結構或駕駛座旁的擋風玻璃上，擇一拍攝即可。' },
//   { title: '里程數', desc: '請拍攝儀表板顯示畫面，並確認里程數清晰可辨。' },
//   { title: '行照', desc: '請確認行照資料清晰可辨。' }
// ];

class SurveyVehicle extends React.Component<IProps, IState> {
  state: IState = {
    currentStep: 1,
    currentPage: 1,
    carSurveyImgs: new Array(0),
    surveyStepInfos: new Array(0),
    UICodes: new Array(0),
    carSurveyDoneCode: new Array(0),
    APPLY_NO: '',
    VEHICLE_PNO: '',
    finish: false
  }

  componentDidMount = async () => {
    if (!this.props.history.location.state && !this.props.match.params.uuid) {
      this.props.history.goBack();
      return;
    }

    // 若非行動裝置，提示錯誤訊息並不得繼續
    if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      const UICodes = await apiCommonService.fetchCodeTables(CodeClass.UI);
      if (UICodes) {
        sweetAlertService.modal({
          icon: SweetAlertIcon.Info,
          html: commonService.getCodeMsg(UICodes, CodeId.W029)
        }).then(() => {
          this.props.history.replace(RouterSettings.Home);
        });
      }

      return;
    }

    let applyNoVal;
    let vehiclePNoVal;
    if (this.props.match.params.uuid) {
      const boCarSurverRes = await service.boCarSurveyValidate(this.props.match.params.uuid);
      if (typeof boCarSurverRes === 'string') {
        sweetAlertService.modal({
          icon: SweetAlertIcon.Info,
          html: `${boCarSurverRes}`
        }).then(() => {
          this.props.history.replace(RouterSettings.Home);
        });
        return;
      }

      applyNoVal = boCarSurverRes.APPLY_NO;
      vehiclePNoVal = boCarSurverRes.VEHICLE_PNO;
    }

    if (this.props.history.location.state) {
      const { applyNo, vehiclePNo }: any = this.props.history.location.state;
      applyNoVal = applyNo;
      vehiclePNoVal = vehiclePNo;
    }

    const initSetting = await service.fetchInitSetting(applyNoVal, vehiclePNoVal);

    const carSurveyImgNull = initSetting.carSurveyImgs.filter(x => x.IMAGE_URL === null);

    let currentStep = 1;
    let currentPage = 1;
    let finish = false;
    if (carSurveyImgNull.length > 0) {
      carSurveyImgNull.sort(function (a, b) {
        return a.STEP - b.STEP;
      });
      currentStep = this.handleGetStep(carSurveyImgNull[0].STEP, initSetting.surveyStepInfo);
      currentPage = carSurveyImgNull[0].STEP;
    } else {
      currentStep = initSetting.surveyStepInfo.length;
      finish = true;
    }

    this.setState({
      currentStep: currentStep,
      currentPage: currentPage,
      carSurveyImgs: [...initSetting.carSurveyImgs],
      surveyStepInfos: [...initSetting.surveyStepInfo],
      UICodes: [...initSetting.UICodes],
      carSurveyDoneCode: [...initSetting.carSurveyDoneCodes],
      APPLY_NO: applyNoVal,
      VEHICLE_PNO: vehiclePNoVal,
      finish: finish
    });
  }

  componentDidUpdate () {
    // console.log('state', this.state);
  }

  /**
   * @description 取得拍照步驟
  */
  handleGetStep = (currentPage:number, surveyStepInfos:SurveyStepInfoContent[]) => {
    const surveyStepInfo = _.find(surveyStepInfos, (surveyStepInfo:SurveyStepInfoContent) => {
      return (_.findIndex(surveyStepInfo.ITEM_LIST, (item:StepInfoItemContent) => item.PARAM_ORDER === currentPage)) !== -1;
    });

    if (!surveyStepInfo) return 1;

    return surveyStepInfo.PARAM_ORDER;
  }

  /**
   * @description 取得拍照步驟的範例圖片位址
  */
  handleGetDemoImgUrl = (currentPage:number, surveyStepInfos:SurveyStepInfoContent[]) => {
    const surveyStepInfo = _.find(surveyStepInfos, (surveyStepInfo:SurveyStepInfoContent) => {
      return (_.findIndex(surveyStepInfo.ITEM_LIST, (item:StepInfoItemContent) => item.PARAM_ORDER === currentPage)) !== -1;
    });

    if (!surveyStepInfo) return '';

    const stepInfo = _.find(surveyStepInfo.ITEM_LIST, (stepInfo:StepInfoItemContent) => stepInfo.PARAM_ORDER === currentPage);
    if (!stepInfo) return '';

    return stepInfo.DEMO_IMAGE_URL;
  }

  handleUpload = async (imgBase64: string) => {
    // console.log(imgBase64);
    const res = await service.imageUpload(
      this.state.APPLY_NO, this.state.VEHICLE_PNO, this.state.currentPage, imgBase64
    );

    if (!res) return;

    sweetAlertService.modal({
      html: '上傳成功',
      showCancelButton: false,
      showCloseButton: true
    }).then(async res => {
      const imageList = await service.fetchImageList(this.state.APPLY_NO, this.state.VEHICLE_PNO);

      if (res.value) {
        var imageNull = imageList?.CAR_SURVEY_IMAGE.filter(x => x.IMAGE_URL === null) as CarSurveyImage[];

        if (imageNull?.length > 0) {
          imageNull.sort(function (a, b) {
            return a.STEP - b.STEP;
          });
          // console.log('imageList', imageList);
          // console.log('currentPage', imageNull[0].STEP);
          // console.log('currentStep', this.handleGetStep(imageNull[0].STEP, this.state.surveyStepInfos));
          this.setState({
            currentStep: this.handleGetStep(imageNull[0].STEP, this.state.surveyStepInfos),
            currentPage: imageNull[0].STEP
          });
        } else {
          // 完成拍照
          this.setState({
            currentStep: this.state.surveyStepInfos.length,
            finish: true
          });

          // console.log('完成');
        }
      }
    });
  };

  render () {
    let steps:IStepElems[] = new Array(0);
    if (this.state.surveyStepInfos.length > 0) {
      steps = _.map(this.state.surveyStepInfos, (surveyStepInfo:any, index:number) => {
        return {
          index: surveyStepInfo.PARAM_ORDER < 10 ? `0${surveyStepInfo.PARAM_ORDER}` : `${surveyStepInfo.PARAM_ORDER}`,
          text: index === this.state.surveyStepInfos.length - 1 && this.state.finish
            ? commonService.getCodeMsg(this.state.carSurveyDoneCode, CodeId.CSD01)
            : surveyStepInfo.PARAM_TEXT
        };
      });
    }

    let content:IContent = {
      title: '',
      desc: ''
    };

    if (this.state.surveyStepInfos.length > 0) {
      _.forEach(this.state.surveyStepInfos, (surveyStepInfo:SurveyStepInfoContent) => {
        const item = _.find(surveyStepInfo.ITEM_LIST, (item:StepInfoItemContent) => item.PARAM_ORDER === this.state.currentPage);
        if (!item) return;

        content = {
          title: item.PARAM_TEXT,
          desc: item.PARAM_VALUE
        };
      });
    }

    return (
      <div className="survey-vehicle">
        <div className="template-container">
          <div className="survey-vehicle__header">
            <SurveyStepBar
              stepElems={steps}
              currentStep={this.state.currentStep}
            />
          </div>
          <div className="survey-vehicle__content">
            {
              this.state.finish
                ? (
                  <SurveyCompleted
                    carSurveyDoneCode={this.state.carSurveyDoneCode}
                  />
                )
                : (
                  <SurveyPage
                    content={content}
                    remindText={commonService.getCodeMsg(this.state.UICodes, CodeId.W030)}
                    onUpload={this.handleUpload}
                    demoImgUrl={this.handleGetDemoImgUrl(this.state.currentPage, this.state.surveyStepInfos)}
                  />
                )
            }
          </div>
        </div>
      </div>
    );
  }
}

export default SurveyVehicle;
